import { createApiHook } from '../hooks';
import { billingApiFactory } from './billingApiFactory';

export const useBillingApi = createApiHook(billingApiFactory);
